import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCrown,
  faArrowLeft
} from '@fortawesome/free-solid-svg-icons';

import PlansComparison from './PlansComparison.jsx';

import './LoggedPremiumPlans.css';

const LoggedPremiumPlans = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="logged-premium-plans">

      <div className="logged-premium-plans__header">

        <button
          type="button"
          className="logged-premium-plans__back"
          onClick={handleBack}
          aria-label="Inapoi"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>

       

      </div>

      <PlansComparison showFreePlan={false} />

    </div>
  );
};

export default LoggedPremiumPlans;